import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import type { CRMEntity } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

import ExportToSalesforceDropdownItem from "../../components/ExportToSalesforceDropdownItem/ExportToSalesforceDropdownItem";
import {
    selectIsCompanyAsLeadExportClaimEnabled,
    selectIsSalesForceNotIntegrated,
    selectSalesforceContactsToggleState,
    selectSalesforceLeadsToggleState,
} from "../../store/selectors/salesforceSelectors";

type ContactsSalesforceExportItemContainerProps = {
    onClick(destination: string, as?: CRMEntity): void;
    tooltipDisabledContent?: string;
    isUseLockedIcon?: boolean;
    isExportDisabled?: boolean;
};

const ContactsSalesforceExportItemContainer = ({
    onClick,
    tooltipDisabledContent,
    isUseLockedIcon,
    isExportDisabled,
}: ContactsSalesforceExportItemContainerProps) => {
    const isSalesforceNotIntegrated = useSelector(selectIsSalesForceNotIntegrated);
    const isSalesforceContactsExportEnabled = useSelector(selectSalesforceContactsToggleState);
    const isSalesforceLeadsExportEnabled = useSelector(selectSalesforceLeadsToggleState);
    const isCompanyAsLeadExportClaimEnabled = useSelector(selectIsCompanyAsLeadExportClaimEnabled);

    const enabledEntity: CRMEntity = isSalesforceContactsExportEnabled ? "contact" : "lead";

    if (isSalesforceNotIntegrated) {
        return null;
    }

    if (tooltipDisabledContent || isExportDisabled) {
        return (
            <ExportToSalesforceDropdownItem
                isDisabled
                isUseLockedIcon={isUseLockedIcon}
                text={translate("si.contacts_search.action.export.variant.salesforce.text")}
                tooltipDisabledContent={tooltipDisabledContent}
            />
        );
    }

    if (
        (!isSalesforceContactsExportEnabled && !isSalesforceLeadsExportEnabled) ||
        (isCompanyAsLeadExportClaimEnabled && !isSalesforceContactsExportEnabled)
    ) {
        return (
            <ExportToSalesforceDropdownItem
                isDisabled
                isUseLockedIcon={isUseLockedIcon}
                text={translate("si.contacts_search.action.export.variant.salesforce.text")}
                tooltipDisabledContent={translate("si.contacts_search.action.variant.export_to_crm.disabled")}
            />
        );
    }

    if (isSalesforceContactsExportEnabled && isSalesforceLeadsExportEnabled && !isCompanyAsLeadExportClaimEnabled) {
        return (
            <>
                <ExportToSalesforceDropdownItem
                    text={`${translate("si.contacts_search.action.export.variant.salesforce.text")}:`}
                />
                <ExportVariantsDropdownItem
                    variant="contacts"
                    text={translate("si.contacts_search.action.export.variant.contacts.text")}
                    onClick={() => onClick("salesforce", "contact")}
                />
                <ExportVariantsDropdownItem
                    variant="leads"
                    text={translate("si.contacts_search.action.export.variant.leads.text")}
                    onClick={() => onClick("salesforce", "lead")}
                />
            </>
        );
    }

    return (
        <ExportToSalesforceDropdownItem
            text={translate("si.contacts_search.action.export.variant.salesforce.text")}
            onClick={() => onClick("salesforce", enabledEntity)}
        />
    );
};

export default ContactsSalesforceExportItemContainer;
